export const formatEmailToName = (email: string | null | undefined): string => {
  if (!email) return 'Unknown';
  const [handle] = email.split('@');
  if (!handle) return 'Unknown';

  const parts = handle.split('.');
  if (parts.length !== 2) return handle;

  const [lastName, firstName] = parts;
  return `${firstName.charAt(0).toUpperCase() + firstName.slice(1)} ${
    lastName.charAt(0).toUpperCase() + lastName.slice(1)
  }`;
};

export const formatStatusText = (status: string): string => {
  switch (status.toLowerCase()) {
    case 'inprogress':
    case 'in_progress':
    case 'in-progress':
      return 'In Progress';
    case 'todo':
    case 'to_do':
    case 'to-do':
      return 'Todo';
    case 'done':
    case 'completed':
      return 'Completed';
    default:
      // Capitalize first letter of each word for custom statuses
      return status
        .split(/[-_\s]/)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
  }
};

export const formatMilestoneType = (type: string): string => {
  switch (type.toLowerCase()) {
    case 'planning':
      return 'Planning Session';
    case 'review':
      return 'Review';
    case 'approval':
      return 'Approval';
    case 'qc':
      return 'QC';
    case 'production':
      return 'Production Day';
    case 'retrospective':
      return 'Retrospective';
    case 'deadline':
      return 'Deadline';
    case 'delivery':
      return 'Delivery';
    case 'launch':
      return 'Launch';
    default:
      // For custom types, capitalize each word
      return type
        .split(/[-_\s]/)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
  }
};
